module.exports = __webpack_public_path__ + "img/range0.a01b604b.png";